import env from '@/env';
import createApiClient from '../authorized-api-client';

const countryInformationApisClient = createApiClient(env.api.baseUrl.countryInformation);

export default countryInformationApisClient;
